import React from 'react';
import Badge from './Badge';

const Logos = () => {
  // Placeholder for client logos - using text badges for now
  const clients = [
    'Local Startups',
    'E-commerce Stores',
    'Service Businesses',
    'Creative Agencies',
    'Restaurants & Cafes',
    'Professional Services'
  ];

  return (
    <section className="section-padding bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="container-xl">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-slate-600 uppercase tracking-wide mb-4">
            Trusted by growing businesses across the Philippines
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl logo-font text-gray-900 mb-6">
            From startups to established companies
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-slate-800 to-slate-600 mx-auto rounded-full"></div>
        </div>

        {/* Client badges */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {clients.map((client, index) => (
            <Badge 
              key={index}
              variant="outline" 
              size="lg"
              className="bg-white border-gray-200 text-gray-700 hover:border-indigo-300 hover:text-indigo-600 transition-colors duration-200"
            >
              {client}
            </Badge>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-8 xl:gap-12 2xl:gap-16 text-center">
          <div className="bg-white rounded-2xl p-6 xl:p-8 2xl:p-10 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="text-4xl xl:text-5xl 2xl:text-6xl font-bold text-slate-800 mb-2">25+</div>
            <div className="text-sm xl:text-base text-gray-600 font-medium">Projects Delivered</div>
          </div>
          <div className="bg-white rounded-2xl p-6 xl:p-8 2xl:p-10 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="text-4xl xl:text-5xl 2xl:text-6xl font-bold text-slate-800 mb-2">100%</div>
            <div className="text-sm xl:text-base text-gray-600 font-medium">Client Satisfaction</div>
          </div>
          <div className="bg-white rounded-2xl p-6 xl:p-8 2xl:p-10 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="text-4xl xl:text-5xl 2xl:text-6xl font-bold text-slate-800 mb-2">Fast</div>
            <div className="text-sm xl:text-base text-gray-600 font-medium">Turnaround Time</div>
          </div>
          <div className="bg-white rounded-2xl p-6 xl:p-8 2xl:p-10 shadow-sm hover:shadow-md transition-shadow duration-300">
            <div className="text-4xl xl:text-5xl 2xl:text-6xl font-bold text-slate-800 mb-2">3-5</div>
            <div className="text-sm xl:text-base text-gray-600 font-medium">Days to Start</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Logos;
